<loading [visible]="loading"></loading>
<form [formGroup]="saveForm"
  class="grid grid-cols-1 md:grid-cols-12 gap-6 max-h-[calc(100vh-150px)]">

  <div
    class="md:col-span-12 flex flex-col md:flex-row justify-between items-center border-b-2 border-black pb-4 h-fit gap-4">

    <span class="text-xl font-black text-black uppercase tracking-[0.2em]">Venta de crédito</span>

    <div class="flex flex-wrap gap-4 items-end">
      <div class="w-32">
        <custom-input label="Año" type="number" [formControlItem]="saveForm.get('year')"></custom-input>
      </div>
      <div class="w-44">
        <custom-input label="Fecha" type="date" [formControlItem]="saveForm.get('date')"></custom-input>
      </div>
      <div class="w-56">
        <label class="block mb-2 text-[10px] font-black text-black uppercase tracking-widest">Vendedor</label>
        <select formControlName="user_id"
          class="w-full px-2 py-1 text-sm border border-black rounded-xl bg-white font-bold focus:ring-2 focus:ring-black/5">
          <option [value]="null">Seleccionar...</option>
          @for(user of dropdowns.users; track user.id){ <option [value]="user.id">{{ user.name }}</option> }
        </select>
      </div>
    </div>
  </div>
  <div class="md:col-span-12 flex flex-col md:flex-row items-center border-b-2 border-black pb-4 h-fit gap-4">
    <div class="bg-white border border-black rounded-xl px-2 py-1 text-sm font-bold">
        <label for="date_start" >Fecha desde: </label>
        <input type="date" id="date_start" name="date_start" (change)="onDateStartChange($event.target.value)">
    </div>
    <div class="bg-white border border-black rounded-xl px-2 py-1 text-sm font-bold">
        <label for="date_end" >Fecha hasta: </label>
        <input type="date" id="date_end" name="date_end" (change)="onDateEndChange($event.target.value)">
    </div>

    <div class="w-64">
      <custom-select
        label="Cliente"
        placeholder="BUSCAR CLIENTE..."
        [formControlItem]="saveForm.get('client_id')!"
        [options]="dropdowns.clients"
        bindValue="value"
        bindLabel="label"
        (selectionChange)="changeClient()">
      </custom-select>
    </div>
    <button type="button" (click)="generateInvoices()" [disabled]="loading" class="cursor-pointer px-6 py-2.5 text-sm font-medium text-black bg-white border border-black focus:outline-none focus:ring-2 focus:ring-blue-300 rounded-lg transition-all duration-200">Descargar</button>
    <button type="button" (click)="generateInvoices(true)" [disabled]="loading" class="cursor-pointer px-6 py-2.5 text-sm font-medium text-black bg-white border border-black focus:outline-none focus:ring-2 focus:ring-blue-300 rounded-lg transition-all duration-200">Descargar y enviar</button>
    <!-- @if(type){
    <h3>{{getType()}}</h3>
    } -->
  </div>

  @if(invoiceResponseError){
    <div class="md:col-span-12 p-4 bg-red-100 border border-red-500 rounded-xl text-sm text-red-800">
      {{ invoiceResponseError }}
    </div>
  }

  @if(invoiceResponse){
    <div class="md:col-span-12 p-4 bg-green-50 border border-green-500 rounded-xl text-sm text-black">
      <div class="font-bold mb-2">Respuesta de facturación</div>
      @if(invoiceResponse.list){
        <div class="mb-2">Facturas generadas: {{ invoiceResponse.list.length }}</div>
        <ul class="list-disc pl-5 space-y-1 mb-4">
          @for(invoice of invoiceResponse.list; track invoice.id){
            <li>Factura #{{ invoice.id_by_company }} - {{ invoice.id_by_company }}/{{ invoice.year }}</li>
          }
        </ul>
      }
      <pre class="whitespace-pre-wrap break-words text-xs">{{ invoiceResponse.message | json }}</pre>
    </div>
  }

  @if(invoiceResponse?.warning){
    <div class="md:col-span-12 p-4 bg-yellow-50 border border-yellow-500 rounded-xl text-sm text-black">
      <div class="font-bold mb-2">Albaranes sin oficina</div>
      {{ invoiceResponse.warning }}
    </div>
  }

  <div class="md:col-span-4 space-y-6 overflow-y-auto pr-2 custom-scroll">

  </div>

</form>